import * as angular from 'angular';
import * as _ from 'lodash';
import GobActivity from "../../models/activity/gobActivity";
import template from './cavityHistory.tpl.html';

export interface CavityHistoryData {
  gob: GobActivity;
}

export function openCavityHistory(data: CavityHistoryData,
                                  $modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'CavityHistoryCtrl as historyCtrl',
    resolve: {
      data: function() {
        return data;
      }
    }
  }).result;
}

export default angular.module('aps.controller.cavityHistory', [])
  .controller('CavityHistoryCtrl', cavityHistoryCtrl)
  .name;

function cavityHistoryCtrl($modalInstance: mm.foundation.modalInstance,
                           data: CavityHistoryData) {
  let vm = this;
  vm.gob = data.gob;
  vm.section = data.gob.section;
  vm.latestTools = _.values(vm.gob.latestTools);

  vm.close = function() {
    $modalInstance.close();
  };
}



// WEBPACK FOOTER //
// ./src/app/controllers/toolHistory/cavityHistory.controller.ts